/**
 * A world offer's link from a Facebook post: `?offer=<id>`, such as
 * `?offer=frost-2026-11`. Only letters, numbers and dashes count.
 */
export function readOfferLink(search: string = window.location.search): string | null {
  const value = new URLSearchParams(search).get('offer')?.trim().toLowerCase() ?? '';
  return /^[a-z0-9-]{1,40}$/.test(value) ? value : null;
}

/** Take the offer out of the address, so a reload doesn't show it again. */
export function clearOfferLink(): void {
  const url = new URL(window.location.href);
  if (!url.searchParams.has('offer')) return;
  url.searchParams.delete('offer');
  window.history.replaceState(window.history.state, '', url.pathname + url.search + url.hash);
}
